import i18n from 'src/i18n/index.js';

class CollectivityLabel {
  constructor(collectivityLabel) {
    const exists = true;
    this.collectivityLabel = exists ? collectivityLabel.toLowerCase() : 'aev';
    this.logo = `statics/whitelabel/logos/${this.collectivityLabel}.svg`;
    this.translation = `${i18n.global.t(`collectivity-labels.${this.collectivityLabel}`)}`;
  }
}

export { CollectivityLabel as default };
